import { useEffect, useState } from 'react';

/*
 * react-slick's own `responsive` breakpoints only react to a matchMedia "change" event, not
 * the query's state at registration time (see react-slick's Slider#media) — so a carousel that
 * mounts already inside a breakpoint's range silently keeps its desktop settings. Use this hook
 * to track a breakpoint ourselves (checked immediately on mount, not just on later changes) and
 * pass the resolved settings to Carousel directly instead of through its `resolutions` prop.
 */
export default function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(() => typeof window !== 'undefined' && window.matchMedia(query).matches);

  useEffect(() => {
    const mql = window.matchMedia(query);
    const update = () => setMatches(mql.matches);

    update();
    mql.addEventListener('change', update);

    return () => mql.removeEventListener('change', update);
  }, [query]);

  return matches;
}
